export type MenuItem = "sep" | { label: string; kbd?: string; danger?: boolean; onClick: () => void };

let current: HTMLElement | null = null;

export function closeContextMenu() {
  if (current) {
    current.remove();
    current = null;
  }
}

export function openContextMenu(x: number, y: number, items: MenuItem[]) {
  closeContextMenu();
  const menu = document.createElement("div");
  menu.className = "ctx-menu";
  for (const it of items) {
    if (it === "sep") {
      const s = document.createElement("div");
      s.className = "ctx-sep";
      menu.appendChild(s);
      continue;
    }
    const b = document.createElement("button");
    b.className = "ctx-item" + (it.danger ? " danger" : "");
    b.innerHTML = `<span>${it.label}</span>${it.kbd ? `<span class="kbd">${it.kbd}</span>` : ""}`;
    b.addEventListener("click", () => {
      closeContextMenu();
      it.onClick();
    });
    menu.appendChild(b);
  }
  document.body.appendChild(menu);
  // keep in viewport
  const r = menu.getBoundingClientRect();
  const px = Math.min(x, window.innerWidth - r.width - 8);
  const py = Math.min(y, window.innerHeight - r.height - 8);
  menu.style.left = px + "px";
  menu.style.top = py + "px";
  current = menu;

  const onDown = (e: PointerEvent) => {
    if (current && !current.contains(e.target as Node)) {
      closeContextMenu();
      window.removeEventListener("pointerdown", onDown, true);
    }
  };
  setTimeout(() => window.addEventListener("pointerdown", onDown, true), 0);
}
